import { Translation } from "./Language";

export type LabelKey =
    "main.test"
    | "main.blog.empty"
    | "main.subscription.title"
    | "main.subscription.button.label"
    | "main.subscription.button.subtitle"
    | "main.select-expedition"
    | "main.open.gallery"
    | "main.offline.title"
    | "main.offline.text"
    | "main.offline-live.text"
    | "main.offline.reload"
    | "main.offline.ignore";

export class Label {

    public static lookup: { [key: string]: Translation } = {};

    public static label(uiLabelKey: LabelKey): Translation | null {

        if (e5.Debug.active("show-labels")) {
            return {
                de: uiLabelKey,
                en: uiLabelKey
            };
        }

        if (!this.lookup[uiLabelKey]) {
            console.warn("Could not translate ui-label. Language.data is null!");
            return "";
        }
        return this.lookup[uiLabelKey];
    }

    public static set(element: HTMLElement, uiLabelKey: LabelKey, attr: string = ""): void {
        lang.set(element,
            lang.type(attr, this.label(uiLabelKey))
        );
    }
}

Label.lookup = (window as any).e5Labels;